import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Platform } from "types/platform";

let cachedPlatforms: Platform[] | null = null;
let platformsInFlight: Promise<Platform[]> | null = null;

export const usePlatforms = (enabled: boolean = true) => {
  const [platforms, setPlatforms] = React.useState<Platform[]>(() => cachedPlatforms || []);
  const [fetching, setFetching] = React.useState(enabled ? !cachedPlatforms : false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    if (!enabled) return;
    if (cachedPlatforms) {
      setPlatforms(cachedPlatforms);
      setFetching(false);
      return;
    }
    (async () => {
      const data = await getPlatforms();
      if (data) setPlatforms(data);
    })();
  }, [enabled]);

  const getPlatforms = async (): Promise<Platform[] | null> => {
    if (cachedPlatforms) return cachedPlatforms;
    if (platformsInFlight) return platformsInFlight;
    try {
      setFetching(true);
      platformsInFlight = axios
        .get(
          `${API_BASE_URL}${API_URLS.Platforms}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        )
        .then((r) => (r.data?.data || []) as Platform[]);
      const data = await platformsInFlight;
      cachedPlatforms = data;
      return data;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      platformsInFlight = null;
      setFetching(false);
    }
  };
  return { platforms, fetching };
};
